







































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
@Component
export default class UIActions extends Vue {
  @Prop(Array) readonly selected: object[];
  fab = true;
  isOpen = false;
}
